import React from 'react';
import PropTypes from 'prop-types';
import { RevisorProvider } from '@weezevent/revisor-front';
import { fetcher } from '@weezevent/weezjs-core';
import { usePermissions } from '../user/permissions';

// Temporary adapter: weezjs-core fetcher returns { response } but revisor-front expects { data }
// The API returns paginated { data: [...], page, total, per_page } — unwrap to flat array
const revisionsFetcher = {
    get: (url, options) => fetcher.get(url, { ...options, allow_cache: false }).then(({ response }) => ({ data: response?.data || [] }))
};

export const RevisorProviderWrapper = ({ children }) => {
    const permissions = usePermissions();

    return (
        <RevisorProvider baseUrl={window.weezConfig.api.apiUrl} fetcher={revisionsFetcher} isAdmin={() => permissions.isAdmin()} classNames={{ panel: 'willy-revisor-panel' }}>
            {children}
        </RevisorProvider>
    );
};

RevisorProviderWrapper.propTypes = {
    children: PropTypes.node
};
